import { MagicConfigMixin, ModalMixin, SessionChange } from '@gig/magic-common';
import { Mixins, Prop, Watch, Emit, Component } from 'vue-property-decorator';
import { AML_STATUS_UPDATED, USER_JURISDICTION_QUERY, AML_STATUS_QUERY, GRACE_PERIOD_QUERY, USER_SET_REQUIRES_SOW } from '@gig/magic-messages';
import { importResponsibleGaming } from '../../utils/helpers.js';
import { getGracePeriodDaysLeft, isKYCRequestedByAML, shouldDisplayLinkToWithdraw } from '@gig/magic-jurisdictions';
import { AmlStatus } from '@gig/magic-sdk/dist/adapter/users/getAmlStatus';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
let SowPrompterComponent = class extends Mixins(MagicConfigMixin, ModalMixin) {
  constructor() {
    super(...arguments);
    this.periods = [];
    this.amlStatus = null;
    this.amlStatusSubscription = null;
    this.alreadyShown = false;
  }
  created() {
    this.amlStatusSubscription = window.eventBus.subscribe(AML_STATUS_UPDATED, () => {
      this.fetchAmlAndGracePeriodStatus();
    });
  }
  destroyed() {
    var _a;
    (_a = this.amlStatusSubscription) == null ? void 0 : _a.unsubscribe();
  }
  onSessionChange(isLoggedIn) {
    return __async(this, null, function* () {
      if (!isLoggedIn) {
        this.closeModal();
        this.alreadyShown = false;
        this.actionRequired(false);
        return;
      }
    });
  }
  updateGracePeriodState() {
    return __async(this, null, function* () {
      var _a, _b;
      const daysLeft = getGracePeriodDaysLeft(this.periods);
      const status = (_b = (_a = this.amlStatus) == null ? void 0 : _a.status) != null ? _b : {
        SOWQ: AmlStatus.NOT_SET,
        SOF: AmlStatus.NOT_SET,
        SOWD: AmlStatus.NOT_SET
      };
      const isRequiredToPrompt = !!daysLeft || isKYCRequestedByAML(status);
      if (!isRequiredToPrompt) {
        this.actionRequired(false);
        return;
      }
      if (this.alreadyShown) {
        return;
      }
      if (this.shouldHide) {
        this.closeModal();
      } else {
        yield importResponsibleGaming();
        const countdownModal = document.createElement(this.renderedModal);
        countdownModal.daysLeft = daysLeft;
        const jurisdiction = yield window.queryBus.query(USER_JURISDICTION_QUERY);
        countdownModal.displayWithdrawLink = shouldDisplayLinkToWithdraw(jurisdiction, daysLeft).toString();
        const dismissible = daysLeft > 0;
        this.openModal(countdownModal, this.header, {
          dismissible,
          keepAfterClear: !dismissible,
          onClose: () => {
            if (!this.shouldHide) {
              this.alreadyShown = true;
            }
          }
        });
      }
      this.actionRequired(true, daysLeft);
    });
  }
  fetchAmlAndGracePeriodStatus() {
    return __async(this, null, function* () {
      const [amlStatus, periods] = yield Promise.all([
        window.queryBus.query(AML_STATUS_QUERY),
        window.queryBus.query(GRACE_PERIOD_QUERY)
      ]);
      this.amlStatus = amlStatus;
      this.periods = periods;
      this.updateGracePeriodState();
    });
  }
  actionRequired(isActionRequired, daysRemaining) {
    window.commandBus.publish(USER_SET_REQUIRES_SOW, {
      isActionRequired,
      daysRemaining
    });
    return { isActionRequired, daysRemaining };
  }
  render() {
    return null;
  }
  isRequired() {
    return [];
  }
};
__decorateClass([
  Prop({
    type: String,
    default: "magic-sow-countdown-prompt"
  })
], SowPrompterComponent.prototype, "renderedModal", 2);
__decorateClass([
  Prop({
    type: String,
    default: "sow-countdown-prompt.header"
  })
], SowPrompterComponent.prototype, "header", 2);
__decorateClass([
  Prop(Boolean)
], SowPrompterComponent.prototype, "shouldHide", 2);
__decorateClass([
  SessionChange({ immediate: true })
], SowPrompterComponent.prototype, "onSessionChange", 1);
__decorateClass([
  Watch("shouldHide")
], SowPrompterComponent.prototype, "updateGracePeriodState", 1);
__decorateClass([
  Emit("action-required")
], SowPrompterComponent.prototype, "actionRequired", 1);
SowPrompterComponent = __decorateClass([
  Component({
    name: "sow-prompter"
  })
], SowPrompterComponent);

export { SowPrompterComponent };
